import React, { useEffect, useRef } from 'react';

import * as S from './styles';
import { Box } from '@material-ui/core';

interface PageRendererProps {
  index: number;
  renderPageCanvas: (
    pageIndex: number,
    canvas: HTMLCanvasElement | null
  ) => Promise<void>;
  showSinglePage: boolean;
}

export const PageRenderer: React.FC<PageRendererProps> = ({
  index,
  renderPageCanvas,
  showSinglePage,
}) => {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  useEffect(() => {
    renderPageCanvas(showSinglePage ? 1 : index + 1, canvasRef.current);
  }, [index, renderPageCanvas, showSinglePage]);

  return showSinglePage ? (
    <S.ShowSinglePageCanvas ref={canvasRef} />
  ) : (
    <Box>
      <S.MultiPagesCanvas ref={canvasRef} />
    </Box>
  );
};
